import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1886c759"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "table table-hover align-middle" }
const _hoisted_6 = { class: "border-dark border-bottom pb-2" }
const _hoisted_7 = { class: "border-dark border-bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  colspan: 3,
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_11 = { class: "name" }
const _hoisted_12 = ["data-dp-tooltip"]
const _hoisted_13 = { class: "buttons" }
const _hoisted_14 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_15 = ["onClick", "data-dp-tooltip"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "close", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "buttons d-flex justify-content-end align-items-center mt-3" }
const _hoisted_19 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: "Salvus Health",
          mb: 4,
          "back-route": {name: 'pharma-appointments'},
          "show-refresh-button": true,
          onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reloadContent()))
        }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("button", {
                class: "btn btn-hover icon-link",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addModal?.show()), ["prevent"]))
              }, [
                _hoisted_2,
                _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AlertError2, {
              error: this.actionUI.getError()
            }, null, 8, ["error"]),
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", _hoisted_6, [
                _createElementVNode("tr", _hoisted_7, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("apbNumber")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("authenticationToken")), 1),
                  _hoisted_8
                ])
              ]),
              _createElementVNode("tbody", null, [
                (this.actionUI.isNotReady())
                  ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                      key: 0,
                      "n-cols": 3
                    }))
                  : _createCommentVNode("", true),
                (this.actionUI.isReady() && !this.authentications.hasAuthentications())
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                      _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t("noContentFound")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (this.actionUI.isReady() && this.authentications.hasAuthentications())
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(this.authentications.authentications, (authentication) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: authentication.apb_number
                      }, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(authentication.apb_number), 1),
                        _createElementVNode("td", {
                          class: "auth-token fst-italic cu-p",
                          "data-dp-tooltip": _ctx.$t('clickToShow'),
                          "data-dp-position": "top"
                        }, [
                          _createElementVNode("div", {
                            class: "blurred w-100",
                            onClick: _cache[2] || (_cache[2] = (event) => event.target.classList.toggle('show'))
                          }, _toDisplayString(authentication.api_key), 1)
                        ], 8, _hoisted_12),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (_ctx.removeItem(authentication)), ["prevent"]),
                              class: "btn btn-icon btn-danger mx-1",
                              "data-dp-tooltip": _ctx.$t('delete'),
                              "data-dp-position": "left"
                            }, _hoisted_17, 8, _hoisted_15)
                          ])
                        ])
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "modal-id": _ctx.addModalId,
      title: _ctx.$t('add'),
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dp_form, {
          as: "form",
          onSubmit: this.submitData,
          novalidate: ""
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_AlertError2, {
              error: this.actionUI.getError()
            }, null, 8, ["error"]),
            _createVNode(_component_InputText, {
              modelValue: this.authentication.apb_number,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.authentication.apb_number) = $event)),
              modelModifiers: { trim: true },
              name: "apb-number",
              label: _ctx.$t('apbNumber'),
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "label", "errors"]),
            _createVNode(_component_InputText, {
              modelValue: this.authentication.api_key,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.authentication.api_key) = $event)),
              modelModifiers: { trim: true },
              name: "auth-token",
              label: _ctx.$t('authenticationToken'),
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "label", "errors"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_base_modal_button, {
                mode: "close",
                class: "btn btn-outline-primary me-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("button", _hoisted_19, _toDisplayString(_ctx.$t('add')), 1)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}